import type { FirstParameters } from '@looko-corp/acloset-react-kit/src/utils';

import { useSwaggerMutation, useSwaggerQuery0, useSwaggerQuery1 } from '@/axios/hooks/useSwaggerQuery';

import { aclosetApi } from '../acloset-api';

export const queryBaseKeys = {
  tokenList: ['sendbird.tokenList'] as const,
  marketItems: (marketItemId: FirstParameters<typeof aclosetApi.marketItems.marketItemsDetail>) =>
    ['marketItems.marketItems', marketItemId] as const,
  chatroom: (query: FirstParameters<typeof aclosetApi.marketItems.chatroomsList>) =>
    ['marketItems.chatroom', query] as const,
};

/**
 * 샌드버드 토큰 가져오기.
 */
export const useSendbirdTokenList = () =>
  useSwaggerQuery0(aclosetApi.sendbird.tokenList, queryBaseKeys.tokenList, { retry: 1 });

/**
 * 샌드버드 토큰 생성.
 */
export const useSendbirdTokenCreate = () => useSwaggerMutation(aclosetApi.sendbird.tokenCreate);

export const useMarketItemsDetail = (marketItemId: FirstParameters<typeof aclosetApi.marketItems.marketItemsDetail>) =>
  useSwaggerQuery1(aclosetApi.marketItems.marketItemsDetail, queryBaseKeys.marketItems, marketItemId, {
    enabled: !!marketItemId,
  });

export const useChatroomsList = (query: FirstParameters<typeof aclosetApi.marketItems.chatroomsList>) =>
  useSwaggerQuery1(aclosetApi.marketItems.chatroomsList, queryBaseKeys.chatroom, query);
